const INITIAL_DATA_ID = "initial-data";
const INITIAL_DATA_ATTRIBUTE = "data-react";
const ERROR_TRACKING_USER_DATA_ID = "error-tracking-user";

// matches general views ReactBundleView._error_tracking_user
export interface ErrorTrackingUserData {
  id: number;
  email: string;
}
export const getErrorTrackingUserData = (): ErrorTrackingUserData | null => {
  const initialStringifiedData = document
    .getElementById(ERROR_TRACKING_USER_DATA_ID)
    ?.getAttribute(INITIAL_DATA_ATTRIBUTE);

  if (!initialStringifiedData) {
    return null;
  }

  return JSON.parse(initialStringifiedData);
};

/**
 * Gets the initial data set on the backend.
 * Set on `<meta id='initial-data' data-react='{...}' />`
 * @typeParam T the expected type of the data, as a contract with the server
 * */
export const getInitialData = <T>(): T => {
  // In test environment, provide a mock initial data
  if (typeof document === "undefined") {
    return {} as T;
  }

  const initialStringifiedData = document
    .getElementById(INITIAL_DATA_ID)
    ?.getAttribute(INITIAL_DATA_ATTRIBUTE);

  if (!initialStringifiedData) {
    throw new Error(
      "No initial data found!" +
        `Please make sure you have an element with an id of '${INITIAL_DATA_ID}' ` +
        `and an attribute of '${INITIAL_DATA_ATTRIBUTE}'. ` +
        `Example: <meta id='${INITIAL_DATA_ID}' ${INITIAL_DATA_ATTRIBUTE}='JSON_STRINGIFIED_DATA' />`,
    );
  }
  return JSON.parse(initialStringifiedData) as T;
};
